import {inject, Injectable} from '@angular/core';
import {FileViewModel} from '../models/file.view-model';
import {FileDto} from '@dto/files/file.dto';
import {UrlService} from '@shared/services/url.service';
import {FILE_DOWNLOAD} from '../../config/urls';

@Injectable({
  providedIn: 'root'
})
export class FileConverterService {
  private readonly urlService = inject(UrlService);

  public convertFileDtosToFileViewModels(fileDtos: FileDto[]): FileViewModel[] {
    if (!fileDtos) {
      return [];
    }
    return fileDtos.map(c => this.convertFileDtoToFileViewModel(c));
  }

  public convertFileDtoToFileViewModel(fileDto: FileDto): FileViewModel {
    const downloadUrl = this.urlService.buildUrl(FILE_DOWNLOAD, fileDto.id, fileDto.filename);

    return {
      id: fileDto.id,
      filename: fileDto.filename,
      title: fileDto.title,
      description: fileDto.description,
      downloadUrl: downloadUrl,
      lineNo: fileDto.lineNo
    };
  }
}
